import css from 'styled-jsx/css';

export default css`
  .link-wrapper a {
    color: var(--primary);
  }
`;
